import axios from "axios";
import { setShowReloginModal } from "../features/login/login";
const env = process.env.REACT_APP_ENV;
const baseUrl = process.env.REACT_APP_LEGACY_URL;
let store;

export const injectStore = (_store) => {
  store = _store;
};
const axiosInstance = axios.create({
  baseURL: baseUrl,
});

// --- Request Interceptor ---
axiosInstance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("q2p_token");

    if (token) {
      config.headers["X-Api-Key"] = token;
    }

    if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => Promise.reject(error),
);

// --- Response Interceptor ---
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // const store = useStore();
    const status = error.response;
    const errorKey = Object?.keys(status?.data?.errors || {});
    if (
      errorKey?.includes("token_expired") ||
      status?.data?.errors?.token_expired
    ) {
      store.dispatch(setShowReloginModal());
    }

    if (status === 404 && env !== "prod") {
      //  CommonToast({
      //    text: status,
      //    icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
      //    variant: "var(--error)",
      //    buttonNeeded: false,
      //  });
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
